import { RESEND_TASK, RESEND_TASK_SUCCESSFUL, RESEND_TASK_FAILED } from './actionTypes';

const initialState = {
    resendTaskError: null, messageResend: null, loadingResendTask: false
}

const resendTask = (state = initialState, action) => {
    switch (action.type) {
        case RESEND_TASK:
            state = {
                ...state,
                loadingResendTask: true,
                resendTaskError: null,
                messageResend: null,
            }
            break;
        case RESEND_TASK_SUCCESSFUL:
            state = {
                ...state,
                loadingResendTask: false,
                messageResend: action.payload,
                resendTaskError: null
            }
            break;
        case RESEND_TASK_FAILED:
            state = {
                ...state,
                messageResend: null,
                loadingResendTask: false,
                resendTaskError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default resendTask;